import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import socketStore from './store/modules/Socket/index'
import i18n from './plugins/i18n'
//import VueMqtt from 'vue-mqtt';
//import VueSocketIO from 'vue-socket.io'
import VueNativeSock from 'vue-native-websocket'
import VueFormWizard from 'vue-form-wizard'
import axios from "./utils/axios";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'vue-multiselect/dist/vue-multiselect.min.js'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { Datetime } from 'vue-datetime'
import VueCookie from 'vue-cookie'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import 'leaflet/dist/leaflet.css';
import {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
} from './mutationTypes'
export const eventBus = new Vue();
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueFormWizard)
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.$VUE_APP_API_SERVER = window.VUE_APP_API_SERVER;

Vue.use(Datetime)
Vue.use(VueCookie);

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

const mutations = {
  SOCKET_ONOPEN,
  SOCKET_ONCLOSE,
  SOCKET_ONERROR,
  SOCKET_ONMESSAGE,
  SOCKET_RECONNECT,
  SOCKET_RECONNECT_ERROR
}

Vue.use(VueNativeSock, process.env.VUE_APP_SOCKET_SERVER, {
  store: socketStore,
  mutations: mutations,
  //connectManually: true,
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
  reconnectionDelay: 3000, // (Number) how long to initially wait before attempting a new (1000)
  passToStoreHandler: function (eventName, event, next) {
    let target = eventName.toUpperCase()
    if(target == "SOCKET_ONMESSAGE"){
      let data;
      if(typeof event.data == 'object')
        data = {event:'camera' , data: event.data}
      else
        data = JSON.parse(event.data)
      this.store.dispatch(data.event, data.data)
    }
    next(eventName, event)
  }
})

var vm = new Vue({
  el: '#app',
  store,
  i18n,
  router,
  components: { App },
  template: '<App/>',
})

global.vm = vm; 


// WEBPACK FOOTER //
// ./src/main.js